import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/admin/ventas.css';
import * as globals from './../../components/GlobalScripts.js';
import { useNavigate } from 'react-router-dom';

const Admin_ventas = () => {
    let path_api = localStorage.getItem('path_api');
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [ventas, setVentas] = useState([]);
    const [selectedVentas, setSelectedVentas] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        get_ventas();
    }, [search, currentPage]);

    const get_ventas = async () => {
        globals.validateSession();
        await axios.post(`${path_api}/admin/ventas.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: currentPage,
            search: search,
            limit: 10
        }).then(response => {
            if (response.data.mensaje === "success") {
                setVentas(response.data.ventas);
                setTotalPages(response.data.total_pages);
                setSelectedVentas([]);
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "No se obtuvieron las ventas", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error 'log-ventas-1'", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleRowClick = (id) => {
        navigate(`/admin/ventas/${id}`);
    };

    const handleSelectVenta = (id) => {
        if (selectedVentas.includes(id)) {
            setSelectedVentas(prev => prev.filter(pid => pid !== id));
        } else {
            setSelectedVentas(prev => [...prev, id]);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = ventas.map(v => v.id);
            setSelectedVentas(allIds);
        } else {
            setSelectedVentas([]);
        }
    };

    const deleteSelected = async () => {
        if (selectedVentas.length === 0) {
            globals.createAlert({ type: "info", msg_title: "Info", msg: "No hay ventas seleccionadas para eliminar", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        await axios.post(`${path_api}/admin/delete_ventas.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            ids: selectedVentas
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Ventas eliminadas correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                get_ventas();
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "Error al eliminar ventas", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al eliminar ventas", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    return (
        <>
            <h2>Listado de ventas</h2>

            <div className='container-nav-search'>
                <div>
                    <label>Filtrar</label>
                    <input
                        type="text"
                        placeholder="Escribe para filtrar por entorno, divisa o estatus"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                {selectedVentas.length > 0 && (
                    <button onClick={deleteSelected} className='delete-button'>
                        Eliminar ({selectedVentas.length})
                    </button>
                )}
            </div>

            <div className='container-table ventas'>
                <table>
                    <thead>
                        <tr>
                            <th style={{maxWidth: "40px"}}><input type="checkbox" onChange={handleSelectAll} checked={selectedVentas.length === ventas.length && ventas.length > 0} /></th>
                            <th style={{maxWidth: "100px"}}>ID</th>
                            <th>Fecha</th>
                            <th>Entorno</th>
                            <th style={{maxWidth: "150px"}}>Valor</th>
                            <th style={{maxWidth: "100px"}}>$</th>
                            <th style={{maxWidth: "150px"}}>Estatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ventas.map((venta) => {
                            const isSelected = selectedVentas.includes(venta.id);
                            return (
                                <tr key={venta.id} type={venta.payment_status}>
                                    <td style={{maxWidth: "40px"}}>
                                        <input type="checkbox" checked={isSelected} onChange={() => handleSelectVenta(venta.id)} />
                                    </td>
                                    <td style={{maxWidth: "100px"}} onClick={() => handleRowClick(venta.id)}>{venta.id}</td>
                                    <td onClick={() => handleRowClick(venta.id)}>{venta.createAt}</td>
                                    <td onClick={() => handleRowClick(venta.id)}>{venta.type_sell}</td>
                                    <td style={{maxWidth: "150px"}} onClick={() => handleRowClick(venta.id)}>{venta.value}</td>
                                    <td style={{maxWidth: "100px"}} onClick={() => handleRowClick(venta.id)}>{venta.divisa}</td>
                                    <td style={{maxWidth: "150px"}} onClick={() => handleRowClick(venta.id)}>{venta.payment_status}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <div className="pagination">
                    <div>
                        <span>Mostrando <b>{ventas.length}</b> ventas</span>
                    </div>
                    <div>
                        <button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                            Anterior
                        </button>
                        <span>Página <b>{currentPage}</b> de <b>{totalPages}</b></span>
                        <button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Admin_ventas;
